import { TeamNanoID } from '../teams/teamsTypes';
import { UserNanoID, UserID } from '../users/usersTypes';
import { FetchOperationCacheKey } from './operationsTypes';

export class OperationCache {
  static showCacheKey() {
    return 'operation' as FetchOperationCacheKey;
  }

  static indexCacheKey() {
    return 'operations' as FetchOperationCacheKey;
  }

  static workerOperations(userNanoId: UserNanoID) {
    return `worker-${userNanoId}-operations`;
  }

  static companyOperations(teamNanoId: TeamNanoID) {
    return `company-${teamNanoId}-operations`;
  }

  static dashboardCompanyOperations(teamNanoId: TeamNanoID) {
    return `dashboard-company-${teamNanoId}-operations`;
  }

  static companyUserOperations(userId: UserID) {
    return `company-user-${userId}-operations`;
  }

  static dashboardCompanyUserOperations(userId: UserID) {
    return `dashboard-company-user-${userId}-operations`;
  }

  static companyMyOperations(teamNanoId: TeamNanoID, userId: UserID) {
    return `company-${teamNanoId}-my-${userId}-operations`;
  }

  static leaveOfAbsenceOperations() {
    return 'leave-of-absence-operations' as FetchOperationCacheKey;
  }
}
